import { tweakcnThemes } from "./themeData";

/**
 * Default theme preset to apply to all users on first visit.
 * Change this value to set a different default theme for all users.
 *
 * Available themes can be found in tweakcnPresets.ts
 * Examples: "modern-minimal", "violet-bloom", "t3-chat", "mocha-mousse", etc.
 */
export const DEFAULT_THEME_PRESET = "violet-bloom";

/**
 * Get the default theme preset object
 */
export function getDefaultThemePreset() {
  return tweakcnThemes.find((theme) => theme.value === DEFAULT_THEME_PRESET);
}

